export class HtmlDTO {

    constructor(
      readonly actualName: string,
      readonly newName: string,
      readonly html: string,
      readonly isRenameRequest?: boolean,
    ) {
    }
  }